import axios from 'axios';

axios.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token');
    let parent = localStorage.getItem('parent');
    let serviceparent = localStorage.getItem('serviceparent');
    let person = localStorage.getItem('person');

    let personObj = {};
    if (person) {
      personObj = JSON.parse(person) || {};
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${ token }`;
    }

    if (personObj.parent) {
      config.headers['BaseParent'] = personObj.parent;
    }

    if (parent) {
      config.headers['Parent'] = parent;
    }

    if (serviceparent) {
      config.headers['ServiceParent'] = serviceparent;
    }

    if (person) {
      config.headers['Person'] = JSON.parse(person).id;
    }

    if (String(import.meta.env.VITE_DEBUG_MODE).toLowerCase() === 'true' || String(import.meta.env.VITE_DEBUG_MODE).toLowerCase() === '1') {
      config.params = {
        ...config.params,
        'XDEBUG_SESSION_START': 'PHPSTORM',
      };
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  },
);

export default axios;
